<template>
    <div>
        <div class="btn-group">
            <button 
                @click="increaseFontSize"
                class="btn btn-secondary"
            >
                <b-icon icon="zoom-in"></b-icon>
            </button>
            <button 
                @click="decreaseFontSize"
                class="btn btn-secondary"
            >
                <b-icon icon="zoom-out"></b-icon>
            </button>
        </div>
        <!--button
            class="btn btn-secondary ml-2"
            :aria-label="$t('language')"
            :aria-describedby="$t('language')"
        >
            {{ $t('language') }} <b-icon icon="translate"></b-icon>
        </button-->
    </div>
</template>

<script>
export default {
    props: {
        stepSize: {
            type: Number,
            default: 2,
        }

    },
    data() {
        return {
            fontSize: 16
        }; 
    },
    mounted(){
        this.updateFontSize();
    },
    methods: {
        increaseFontSize() {
            this.fontSize = this.fontSize + this.stepSize
            this.updateFontSize() 
        },
        decreaseFontSize() {
        if (this.fontSize > 10) {
            this.fontSize = this.fontSize - this.stepSize
            this.updateFontSize() 
        }
        },
        updateFontSize() {
            document.documentElement.style.setProperty("--font-size", `${this.fontSize}px`);
        },
    },
};
</script>